import {
  styled,
  Box,
  Dialog,
  DialogContent,
  IconButton,
  dialogClasses,
} from '@mui/material';

export const DialogReportsContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    width: '100%',
  },
});

export const DialogReportsHeader = styled(Box)(({ theme }) => ({
  flex: 'none',
  padding: theme.spacing(2, 3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const DialogReportsHeaderCloseIcon = styled(IconButton)(({ theme }) => ({
  color: theme.palette.grey[500],
}));

export const DialogReportsContent = styled(DialogContent)({
  display: 'flex',
  flexDirection: 'column',
});
